<template>
  <div class="ticket-suporte-sistema-root">
    <div v-if="embedded">
      <v-alert v-if="!idTipoTicketSuporte" type="warning" dense outlined class="mb-4">
        {{ $t('ticketSuporteSistema.alerts.tipoTicketMissing') }}
      </v-alert>
      <v-form ref="form" v-model="formValid" @submit.prevent="submit">
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="form.solicitante"
              :label="$t('ticketSuporteSistema.fields.solicitante')"
              dense outlined
              :rules="[v => !!(v && String(v).trim()) || $t('ticketSuporteSistema.validation.solicitanteRequired')]"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="form.titulo"
              :label="$t('ticketSuporteSistema.fields.titulo')"
              dense outlined
              :rules="[v => !!(v && String(v).trim()) || $t('ticketSuporteSistema.validation.tituloRequired')]"
            />
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="form.corpo"
              :label="$t('ticketSuporteSistema.fields.descricao')"
              dense outlined
              rows="4"
              auto-grow
              :rules="[v => !!(v && String(v).trim()) || $t('ticketSuporteSistema.validation.descricaoRequired')]"
            />
          </v-col>
          <v-col cols="12">
            <v-file-input
              ref="anexoInput"
              v-model="anexoInputFile"
              :label="anexosFieldLabel"
              dense outlined
              show-size
              prepend-icon="mdi-paperclip"
              :accept="anexoAccept"
              hide-details="auto"
              clearable
              @change="onAnexoSelected"
            />
            <div v-if="anexos.length" class="mt-2">
              <v-chip
                v-for="(file, idx) in anexos"
                :key="'anexo-' + idx + '-' + (file.name || '') + '-' + file.lastModified"
                small
                close
                class="ma-1"
                @click:close="removeAnexo(idx)"
              >
                {{ file.name }}
              </v-chip>
            </div>
          </v-col>
        </v-row>
        <div v-if="!hideSubmitButton" class="d-flex justify-end mt-2">
          <v-btn type="button" color="primary" :loading="loadingSave" :disabled="!idTipoTicketSuporte" @click="submit">
            {{ $t('ticketSuporteSistema.submit') }}
          </v-btn>
        </div>
      </v-form>
    </div>
    <v-container v-else max-width="900px" style="margin-top: 2%">
      <v-card outlined class="elevation-2">
        <v-card-title class="headline" style="color: #4a4a4a">
          {{ $t('ticketSuporteSistema.title') }}
        </v-card-title>
        <v-card-text>
          <v-alert v-if="!idTipoTicketSuporte" type="warning" dense outlined class="mb-4">
            {{ $t('ticketSuporteSistema.alerts.tipoTicketMissing') }}
          </v-alert>
          <v-form ref="form" v-model="formValid" @submit.prevent="submit">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="form.solicitante"
                  :label="$t('ticketSuporteSistema.fields.solicitante')"
                  dense outlined
                  :rules="[v => !!(v && String(v).trim()) || $t('ticketSuporteSistema.validation.solicitanteRequired')]"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="form.titulo"
                  :label="$t('ticketSuporteSistema.fields.titulo')"
                  dense outlined
                  :rules="[v => !!(v && String(v).trim()) || $t('ticketSuporteSistema.validation.tituloRequired')]"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="form.corpo"
                  :label="$t('ticketSuporteSistema.fields.descricao')"
                  dense outlined
                  rows="4"
                  auto-grow
                  :rules="[v => !!(v && String(v).trim()) || $t('ticketSuporteSistema.validation.descricaoRequired')]"
                />
              </v-col>
              <v-col cols="12">
                <v-file-input
                  ref="anexoInput"
                  v-model="anexoInputFile"
                  :label="anexosFieldLabel"
                  dense outlined
                  show-size
                  prepend-icon="mdi-paperclip"
                  :accept="anexoAccept"
                  hide-details="auto"
                  clearable
                  @change="onAnexoSelected"
                />
                <div v-if="anexos.length" class="mt-2">
                  <v-chip
                    v-for="(file, idx) in anexos"
                    :key="'anexo-' + idx + '-' + (file.name || '') + '-' + file.lastModified"
                    small
                    close
                    class="ma-1"
                    @click:close="removeAnexo(idx)"
                  >
                    {{ file.name }}
                  </v-chip>
                </div>
              </v-col>
            </v-row>
            <div class="d-flex justify-end mt-2">
              <v-btn type="button" color="primary" :loading="loadingSave" :disabled="!idTipoTicketSuporte" @click="submit">
                {{ $t('ticketSuporteSistema.submit') }}
              </v-btn>
            </div>
          </v-form>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import apiController from '@/utils/apiController';
import EventBus from '@/utils/eventBus';

const SUPORTE_SISTEMA_ANEXO_ACCEPT =
  'image/jpeg,image/jpg,image/png,image/gif,image/webp,.csv,.txt,.xlsx,.xls,text/csv,text/plain,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,.zip,application/zip,application/x-zip-compressed';
const SUPORTE_SISTEMA_ANEXO_EXT = /\.(jpe?g|png|gif|webp|csv|txt|xlsx|xls|zip)$/i;
const SUPORTE_SISTEMA_TICKET_TYPE_NAME = 'SUPORTE SISTEMA (MERUSTRAKER)';

export default {
  name: 'TicketsSuporteSistema',
  props: {
    embedded: { type: Boolean, default: false },
    hideSubmitButton: { type: Boolean, default: false },
  },
  data() {
    return {
      user: null,
      token: null,
      formValid: true,
      loadingSave: false,
      tiposTickets: [],
      idTipoTicketSuporte: null,
      anexos: [],
      anexoInputFile: null,
      form: {
        solicitante: '',
        titulo: '',
        corpo: '',
      },
    };
  },
  computed: {
    anexoAccept() {
      return SUPORTE_SISTEMA_ANEXO_ACCEPT;
    },
    anexosFieldLabel() {
      if (this.$te('ticketSuporteSistema.fields.anexos')) {
        return this.$t('ticketSuporteSistema.fields.anexos');
      }
      if (this.$te('ticket.tasks.attachFiles')) {
        return this.$t('ticket.tasks.attachFiles');
      }
      return 'Anexos (fotos, CSV, TXT, Excel ou ZIP)';
    },
  },
  watch: {
    loadingSave(val) {
      this.$emit('update:loadingSave', val);
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem('user') || 'null');
    this.token = sessionStorage.getItem('api');
    this.bootstrap();
  },
  methods: {
    async bootstrap() {
      // Tipo de problema e módulo são definidos na edição do card (o ticket nasce Pendente).
      this.loadSolicitante();
      await this.loadTiposTickets();
      this.resolveTipoTicketSuporte();
    },
    loadSolicitante() {
      this.form.solicitante = this.resolveSolicitanteFromUser();
    },
    resolveSolicitanteFromUser() {
      const u = this.user || {};
      return u.nome_usuario || u.login || u.email || '';
    },
    loadTiposTickets() {
      return apiController.request(apiController.endpoints.getallTipostickets, {
        onSuccess: (res) => {
          this.tiposTickets = res.data || [];
        },
      }).catch(() => {});
    },
    resolveTipoTicketSuporte() {
      const list = this.tiposTickets || [];
      const row = list.find(
        (t) => String(t.nome_tipo_ticket || '').trim().toUpperCase() === SUPORTE_SISTEMA_TICKET_TYPE_NAME,
      );
      this.idTipoTicketSuporte = row ? row.id_tipo_ticket : null;
    },
    getSelectedAnexos() {
      return Array.isArray(this.anexos) ? this.anexos.filter(Boolean) : [];
    },
    onAnexoSelected(file) {
      if (!file) return;
      const selected = Array.isArray(file) ? file[0] : file;
      if (!selected) return;
      if (!this.isAnexoPermitido(selected)) {
        const invalidAnexoMsg = this.$te('ticketSuporteSistema.validation.anexoInvalido')
          ? this.$t('ticketSuporteSistema.validation.anexoInvalido')
          : 'Tipo de arquivo não permitido. Envie fotos, CSV, TXT, Excel ou ZIP.';
        EventBus.$emit('show-alert', { tipo: 'warning', mensagem: invalidAnexoMsg });
        this.clearAnexoInput();
        return;
      }
      const duplicate = this.anexos.some(
        (existing) => existing.name === selected.name
          && existing.size === selected.size
          && existing.lastModified === selected.lastModified,
      );
      if (!duplicate) {
        this.anexos.push(selected);
      }
      this.clearAnexoInput();
    },
    removeAnexo(index) {
      if (!Array.isArray(this.anexos)) return;
      this.anexos.splice(index, 1);
    },
    clearAnexoInput() {
      this.anexoInputFile = null;
      this.$nextTick(() => {
        const input = this.$refs.anexoInput;
        if (input && typeof input.reset === 'function') {
          input.reset();
        }
      });
    },
    isAnexoPermitido(file) {
      const name = file && file.name ? String(file.name).trim() : '';
      return SUPORTE_SISTEMA_ANEXO_EXT.test(name);
    },
    normalizeUploadDataUrl(dataUrl, fileName) {
      if (!dataUrl || typeof dataUrl !== 'string') return dataUrl;
      const comma = dataUrl.indexOf(',');
      if (comma < 0) return dataUrl;
      const header = dataUrl.slice(0, comma);
      const data = dataUrl.slice(comma + 1);
      const currentMime = header.slice(header.indexOf(':') + 1, header.indexOf(';')).trim().toLowerCase();
      if (currentMime && currentMime !== 'application/octet-stream') return dataUrl;
      const ext = (fileName || '').split('.').pop().toLowerCase();
      const mimeMap = {
        csv: 'text/csv',
        txt: 'text/plain',
        zip: 'application/zip',
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        xls: 'application/vnd.ms-excel',
        jpg: 'image/jpeg',
        jpeg: 'image/jpeg',
        png: 'image/png',
        gif: 'image/gif',
        webp: 'image/webp',
      };
      const targetMime = mimeMap[ext];
      if (!targetMime) return dataUrl;
      return `data:${targetMime};base64,${data}`;
    },
    uploadOneAnexo(file, index) {
      if (!this.isAnexoPermitido(file)) {
        return Promise.reject(new Error('unsupported file type'));
      }
      const originalName = (file.name && String(file.name).trim()) || `anexo_${index + 1}`;
      const stem = originalName
        .replace(/\.[^.]+$/, '')
        .replace(/[^a-zA-Z0-9._-]/g, '_')
        .slice(0, 120);
      const filename = `ss_${Date.now()}_${index}_${Math.random().toString(36).slice(2, 11)}_${stem || 'anexo'}`;
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const uploadData = {
            file: this.normalizeUploadDataUrl(e.target.result, originalName),
            filename,
            folder: 'suporte_sistema',
          };
          apiController.request(apiController.endpoints.uploadChecklistmedia, {
            data: uploadData,
            silent: true,
            onSuccess: (response) => {
              const d = response.data;
              if (d && !d.error && d.path) {
                const stored = String(d.path).split('/').pop();
                resolve({
                  originalName,
                  storedName: stored,
                  nome_arquivo_original: originalName,
                  nome_arquivo_armazenado: stored,
                  ordem: index,
                });
              } else {
                reject(new Error((d && d.message) || 'upload failed'));
              }
            },
            onError: (err) => reject(err),
          }).catch(reject);
        };
        reader.onerror = () => reject(new Error('FileReader error'));
        reader.readAsDataURL(file);
      });
    },
    async uploadAnexosIfAny() {
      const files = this.getSelectedAnexos();
      if (!files.length) return [];
      const invalid = files.filter((f) => !this.isAnexoPermitido(f));
      if (invalid.length > 0) {
        throw new Error(this.$t('ticketSuporteSistema.validation.anexoInvalido')
          || 'Tipo de arquivo não permitido. Envie fotos, CSV, TXT, Excel ou ZIP.');
      }
      const out = [];
      for (let i = 0; i < files.length; i += 1) {
        // eslint-disable-next-line no-await-in-loop
        const meta = await this.uploadOneAnexo(files[i], i);
        out.push(meta);
      }
      return out;
    },
    async submit() {
      if (this.$refs.form && !this.$refs.form.validate()) {
        EventBus.$emit('show-alert', {
          tipo: 'warning',
          mensagem: this.$t('ticketSuporteSistema.validation.fillAllFields'),
        });
        return;
      }
      if (!this.idTipoTicketSuporte) {
        EventBus.$emit('show-alert', {
          tipo: 'warning',
          mensagem: this.$t('ticketSuporteSistema.alerts.tipoTicketMissing'),
        });
        return;
      }
      this.loadingSave = true;
      try {
        const anexos = await this.uploadAnexosIfAny();
        const body = {
          titulo: String(this.form.titulo).trim(),
          corpo: String(this.form.corpo).trim(),
          id_categoria: null,
          id_usuario_inclusao: this.user.id_usuario,
          id_usuario_ultima_alteracao: this.user.id_usuario,
          nome_usuario_solicitante: String(this.form.solicitante).trim(),
          id_usuario_atribuido: null,
          id_tipo_ticket: this.idTipoTicketSuporte,
          id_tipo_solicitacao: null,
          id_familia_atendimento: null,
          id_tipo_atendimento: null,
          id_servico: null,
          id_equipes: [],
          id_equipamentos: [],
          id_kits: [],
          id_veiculos: [],
          id_tipos_equipamento: [],
          id_tipos_kits: [],
          id_usuarios_visualizadores: [],
          suporte_sistema: {
            id_modulo_sistema: null,
            anexos,
          },
        };
        const response = await apiController.request(apiController.endpoints.insertTicketsuportesistema, {
          data: body,
          silent: true,
        });
        if (response.data && response.data.erro) {
          EventBus.$emit('show-alert', {
            tipo: 'error',
            mensagem: (response.data.mensagem || '').toString(),
          });
          return;
        }
        const id_ticket =
          response.data && (response.data.id_ticket != null ? response.data.id_ticket : response.data.insertId);
        if (id_ticket == null) {
          EventBus.$emit('show-alert', {
            tipo: 'error',
            mensagem: this.$t('ticketSuporteSistema.extensionTicketIdMissing'),
          });
          return;
        }
        EventBus.$emit('show-alert', {
          tipo: 'success',
          mensagem: this.$t('ticketSuporteSistema.success'),
        });
        this.resetFormPartial();
        this.$emit('saved', { id_ticket });
      } catch (e) {
        const invalidAnexoMsg = this.$t('ticketSuporteSistema.validation.anexoInvalido')
          || 'Tipo de arquivo não permitido. Envie fotos, CSV, TXT, Excel ou ZIP.';
        if (e && e.message === 'unsupported file type') {
          EventBus.$emit('show-alert', { tipo: 'warning', mensagem: invalidAnexoMsg });
          return;
        }
        const msg = e.response && e.response.data && (e.response.data.mensagem || e.response.data.message);
        if (msg) {
          EventBus.$emit('show-alert', { tipo: 'error', mensagem: String(msg) });
        } else if (e && e.message === invalidAnexoMsg) {
          EventBus.$emit('show-alert', { tipo: 'warning', mensagem: invalidAnexoMsg });
        } else {
          EventBus.$emit('show-error', { error: e });
        }
      } finally {
        this.loadingSave = false;
      }
    },
    resetFormPartial() {
      this.form = {
        solicitante: this.resolveSolicitanteFromUser(),
        titulo: '',
        corpo: '',
      };
      this.anexos = [];
      this.anexoInputFile = null;
      this.clearAnexoInput();
      if (this.$refs.form) this.$refs.form.resetValidation();
    },
  },
};
</script>
